import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { friendshipAPI } from '../api';
import { Link } from 'react-router-dom';
import api from '../api';
import { t } from '../i18n';

// Resolve backend media URLs to absolute URLs using api.defaults.baseURL
const resolvePhotoUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = (api && api.defaults && api.defaults.baseURL) ? api.defaults.baseURL : '';
  const origin = base.replace(/\/api\/?$/, '');
  if (url.startsWith('/')) return `${origin}${url}`;
  return `${origin}/${url}`;
};

const Friends = () => {
  const { refreshAll } = useContext(AuthContext);
  const [friends, setFriends] = useState([]);
  const [incomingRequests, setIncomingRequests] = useState([]);

  useEffect(() => {
    loadFriends();
    loadIncomingRequests();
  }, []);

  const loadFriends = async () => {
    try {
      const response = await friendshipAPI.getMyFriends();
      setFriends(response.data);
    } catch (err) {
      console.error('Failed to load friends:', err);
    }
  };

  const loadIncomingRequests = async () => {
    try {
      const response = await friendshipAPI.getIncomingRequests();
      setIncomingRequests(response.data);
    } catch (err) {
      console.error('Failed to load requests:', err);
    }
  };

  const handleAccept = async (requestId) => {
    try {
      await friendshipAPI.acceptRequest(requestId);
      loadFriends();
      // inform AuthContext to refresh pending counts immediately
      try { refreshAll && refreshAll(); } catch (e) {}
      loadIncomingRequests();
    } catch (err) {
      console.error('Failed to accept:', err);
    }
  };

  const handleReject = async (requestId) => {
    try {
      await friendshipAPI.rejectRequest(requestId);
      try { refreshAll && refreshAll(); } catch (e) {}
      loadIncomingRequests();
    } catch (err) {
      console.error('Failed to reject:', err);
    }
  };


  return (
    <div className="container">
      <h1 style={{ textAlign: 'center' }}>{t('friends')}</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <Link to="/add-friend" className="btn btn-primary">{t('addFriend')}</Link>
      </div>

      {incomingRequests.length > 0 && (
        <div className="card">
          <h2>{t('incomingRequests')} ({incomingRequests.length})</h2>
          {incomingRequests.map(request => (
            <div key={request.id} style={{ padding: '10px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <strong>{request.from_user.username}</strong>
                {request.from_user.first_name && (
                  <span> - {request.from_user.first_name} {request.from_user.last_name}</span>
                )}
              </div>
              <div>
                <button 
                  className="btn btn-success" 
                  onClick={() => handleAccept(request.id)}
                  style={{ marginRight: '10px' }}
                >
                  {t('accept')}
                </button>
                <button 
                  className="btn btn-danger" 
                  onClick={() => handleReject(request.id)}
                >
                  {t('deny')}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        <h2>{t('myFriends')} ({friends.length})</h2>
        {friends.length === 0 ? (
          <p>{t('noFriendsYet')}</p>
        ) : (
          <div className="friends-grid">
            {friends.map(friendship => (
              <div key={friendship.id} className="friend-card">
                <img
                  className="photo"
                  src={resolvePhotoUrl(friendship.friend.profile_photo)}
                  alt={friendship.friend.username}
                />
                <div className="username">{friendship.friend.username}</div>
                {(friendship.friend.first_name || friendship.friend.last_name) && (
                  <div className="fullname">{[friendship.friend.first_name, friendship.friend.last_name].filter(Boolean).join(' ')}</div>
                )}
                <div className="card-action">
                  <Link to={`/users/${friendship.friend.username}`} className="btn btn-primary">{t('seeProfile')}</Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Friends;
